import React from 'react';
import styled from 'styled-components';
import { Button, ButtonContainer, ButtonContent, GradientButtonProps } from '@components/GradientButton';

type ButtonContainerProps = {
  order?: number;
};

const StyledButtonContainer = styled(ButtonContainer)<ButtonContainerProps>`
  place-self: flex-end;
  order: ${({ order }) => order || null};
`;

type EventButtonProps = GradientButtonProps & ButtonContainerProps;

const EventButton: React.FC<EventButtonProps> = ({ order, href, dataLink, hoverTriggerClass, children }) => {
  return (
    <StyledButtonContainer order={order}>
      <Button href={href} data-link-id={dataLink}>
        <ButtonContent hoverTriggerClass={hoverTriggerClass}>
          <span>{children}</span>
        </ButtonContent>
      </Button>
    </StyledButtonContainer>
  );
};

export default EventButton;
